"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.letterSizeMap = void 0;
var _letterSizeMap = {
    _default: [1.1, 0.5],
    _defaultCapital: [1.6, 0.5],
    a: [1.3, 0.45],
    l: [0.5, 0.5],
    i: [0.4, 0.5],
    j: [0.8, 0.5],
    f: [1, 0.6],
    t: [1, 0.35],
    s: [0.9, 0.6],
    q: [1.2, 0.5],
    w: [1.45, 0.4],
    m: [1.45, 0.45],
    u: [1.1, 0.45],
    e: [1.1, 0.5],
    z: [1.1, 0.5],
    x: [1.1, 0.55],
    '-': [1.25, 0.5],
};
var capitals = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
for (var i = 0; i < capitals.length; i++) {
    var c = capitals[i];
    _letterSizeMap[c] = _letterSizeMap._defaultCapital;
}
exports.letterSizeMap = _letterSizeMap; // : { [key: string]: [number, number] } = {
//   _default: [1.1, 0.5],
//   _defaultCapital: [1.6, 0.5],
//   a: [1.3, 0.45],
//   l: [0.5, 0.5],
//   i: [0.4, 0.5],
//   j: [0.8, 0.5],
//   f: [1, 0.6],
//   t: [1, 0.35],
//   s: [0.9, 0.6],
//   q: [1.2, 0.5],
//   w: [1.45, 0.4],
//   m: [1.45, 0.45],
//   u: [1.1, 0.45],
//   e: [1.1, 0.5],
//   z: [1.1, 0.5],
//   x: [1.1, 0.55],
//   // A: [1.6, 0.5],
//   // B: [1.6, 0.5],
//   // D: [1.6, 0.5],
//   // G: [1.6, 0.5],
//   // H: [1.6, 0.5],
//   // J: [1.6, 0.5],
//   // L: [1.6, 0.5],
//   // M: [1.6, 0.5],
//   // P: [1.6, 0.5],
//   // S: [1.6, 0.5],
//   // T: [1.6, 0.5],
//   '-': [1.25, 0.5],
// }
